import {getQueueCount, outQueue} from "./queue.js";

const FINAL_TARGET = ["browserPopup"];
let isQueueRunning = false;

/**
 * 팝업이 닫기는지 관찰하기 시작합니다.
 * @param target 팝업 객체 식별자.
 * @param checkChildRemove 팝업 객체 식별자.
 * @param callback 팝업 실행 콜백 함수
 * @param next 다음 팝업 관찰을 실행하는 콜백함수
 */
function observePopup({target, checkChildRemove = true, callback}, next) {
    // target이 닫기는지 확인합니다.
    const closeObserver = new MutationObserver(async (mutationsList, thisObserver) => {
        let oneCountFlag = true;
        for (const mutation of mutationsList) {
            const isAttr = mutation.type === 'attributes';
            const isStyle = mutation.attributeName === 'style';
            const isInvisible = mutation.target.style.display === 'none';
            const isDisplayNone = (isAttr && isStyle && isInvisible);

            let isNodeToRemoved = false;
            if (checkChildRemove) {
                isNodeToRemoved = (mutation.type === 'childList') && (mutation.removedNodes.length > 0);
            }

            if ((isDisplayNone || isNodeToRemoved) && oneCountFlag) {
                if (getQueueCount() > 0) {
                    next();
                } else {
                    isQueueRunning = false;
                }
                oneCountFlag = false;
                await thisObserver.disconnect();
            }
        }
    });

    isQueueRunning = true;

    // callback 함수를 호출하여 팝업을 열고 닫기는지 여부를 옵저빙하지 않고 리턴합니다.
    // 이 분기를 타는 타겟은 옵저빙을 하지 않기 때문에 다음 팝업을 실행할 수 없습니다.
    // 그래서 이 분기는 꼭 마지막 팝업이 타야합니다.
    if (FINAL_TARGET.indexOf(target) > -1) {
        if (getQueueCount() > 0) {
            // 마지막 팝업 분기를 거쳤지만, 아직 큐에 팝업이 남았습니다.
            console.error("[POPUP QUEUE] We've gone through the last popup branch, but there are still popups left in the queue.")
        }
        callback();
        isQueueRunning = false;
        return;
    }

    // 주로 팝업 실행 함수가 콜백으로 들어옵니다. 팝업 시작 함수를 콜백으로 실행합니다.
    callback();

    // target 팝업이 닫기는지 확인하기 시작합니다.
    let $target = $(target).get(0);
    if (!$target) {
        isQueueRunning = false;
        return;
    }

    closeObserver.observe($target, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        subtree: true
    });
}

/**
 * 다음 팝업을 옵저빙하기 시작합니다. 재귀함수로 자동으로 다음 큐를 대기시킴.
 */
function nextQueue() {
    observePopup(outQueue(), nextQueue);
}

/**
 * 팝업이 현재 돌아가고 있는지 알기 위한 함수.
 * 깊은 복사로 값을 반환하여 이 함수로 상태변화를 할 수 없습니다.
  * @returns {any}
 */
function getQueueRunStatus() {
    return JSON.parse(JSON.stringify(isQueueRunning));
}

export {observePopup, nextQueue, getQueueRunStatus}
